import React, { useState, useRef, useEffect, useContext } from "react";
import { useTheme } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";
import { format } from "date-fns";
// import { SocketContext } from "../../context/Socket/SocketContext";

import useSound from "use-sound";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import { PiChatCircleDots } from "react-icons/pi";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";

import TicketListItem from "../TicketListItem";
import useTickets from "../../hooks/useTickets";
import alertSound from "../../assets/sound.mp3";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import Favicon from "react-favicon";
import { getBackendUrl } from "../../config";
import defaultLogoFavicon from "../../assets/favicon.ico";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { getTokens } from "../../styles/tokens";
import shouldAlertMessage from "../../helpers/shouldAlertMessage";
import { useMutes } from "../../context/Mutes/MutesContext";
import { canSeeTicketConnection } from "../../utils/connectionScope";

const useStyles = makeStyles(theme => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	const isDark = theme.palette.type === "dark";
	// selo de não lidas igual ao da lista de conversas (verde do WhatsApp)
	const unread = isDark
		? { bg: "#00a884", fg: "#111b21" }
		: { bg: "#25d366", fg: "#ffffff" };
	return {
		// o tema limita todo Popover a 300px; este painel precisa de mais largura
		popoverPaper: {
			width: "360px !important",
			maxWidth: "calc(100vw - 24px) !important",
			marginTop: 8,
			display: "flex",
			flexDirection: "column",
			overflow: "hidden",
			borderRadius: t.radius.md,
			backgroundColor: t.paper,
		},
		panelHeader: {
			flex: "none",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 8,
			padding: "14px 16px 12px",
			borderBottom: `1px solid ${t.line}`,
		},
		panelTitle: {
			margin: 0,
			fontSize: 15,
			fontWeight: 700,
			lineHeight: "20px",
			color: t.text,
		},
		panelCount: {
			flex: "none",
			minWidth: 20,
			height: 20,
			padding: "0 6px",
			borderRadius: 10,
			backgroundColor: unread.bg,
			color: unread.fg,
			fontSize: 11.5,
			fontWeight: 700,
			lineHeight: "20px",
			textAlign: "center",
			fontVariantNumeric: "tabular-nums",
		},
		tabContainer: {
			overflowY: "auto",
			maxHeight: "min(420px, calc(100vh - 160px))",
			padding: 0,
			...theme.scrollbarStyles,
		},
		emptyState: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			gap: 8,
			padding: "32px 20px 36px",
			color: t.textSecondary,
			fontSize: 13,
			textAlign: "center",
			"& svg": {
				fontSize: 34,
				color: t.textMuted,
			},
		},
		badge: {
			backgroundColor: unread.bg,
			color: unread.fg,
		},
	};
});

const NotificationsPopOver = (volume) => {
	const classes = useStyles();
	const theme = useTheme();

	const history = useHistory();
	// const socketManager = useContext(SocketContext);
	const { user, socket } = useContext(AuthContext);
	const { profile, queues } = user;

	const ticketIdUrl = +history.location.pathname.split("/")[2];
	const ticketIdRef = useRef(ticketIdUrl);
	const anchorEl = useRef();
	const [isOpen, setIsOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const queueIds = queues.map((q) => q.id);
	const { get: getSetting } = useCompanySettings();
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);

	const [showTicketWithoutQueue, setShowTicketWithoutQueue] = useState(false);
	const [showNotificationPending, setShowNotificationPending] = useState(false);
	const [showGroupNotification, setShowGroupNotification] = useState(false);

	const [, setDesktopNotifications] = useState([]);

	const { tickets } = useTickets({
		withUnreadMessages: "true"
		// showAll: showTicketWithoutQueue ? "true" : "false"
	});

	const [play] = useSound(alertSound, volume);
	const soundAlertRef = useRef();

	const historyRef = useRef(history);

	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const setting = await getSetting(
					{
						"column": "showNotificationPending"
					}
				);



				if (setting.showNotificationPending === true) {
					setShowNotificationPending(true);
				}

				if (user.allTicket === "enable") {
					setShowTicketWithoutQueue(true);
				}
				if (user.allowGroup === true) {
					setShowGroupNotification(true);
				}
			} catch (err) {
				toastError(err);
			}
		}

		fetchSettings();
	}, [setShowTicketWithoutQueue, setShowNotificationPending]);

	useEffect(() => {
		soundAlertRef.current = play;

		if (!("Notification" in window)) {
			console.log("This browser doesn't support notifications");
		} else {
			Notification.requestPermission();
		}
	}, [play]);

	useEffect(() => {
		const processNotifications = () => {
			// if (showTicketWithoutQueue) {
			setNotifications(tickets);
			// } else {
			// 	const newNotifications = tickets.filter(ticket => ticket.status !== "pending");

			// 	setNotifications(newNotifications);
			// }
		}

		processNotifications();
	}, [tickets]);

	const { isMuted } = useMutes();
	const isMutedRef = useRef(isMuted);
	isMutedRef.current = isMuted;
	// contagem do título/favicon/selo ignora contatos silenciados (a lista mostra todos)
	const unreadCount = notifications.filter(t => !isMuted(t.contactId)).length;

	useEffect(() => {
		ticketIdRef.current = ticketIdUrl;
	}, [ticketIdUrl]);

	useEffect(() => {
		const companyId = user.companyId;
		// const socket = socketManager.GetSocket();
		if (user.id && socket) {
			const queueIds = queues.map((q) => q.id);

			const onConnectNotificationsPopover = () => {
				socket.emit("joinNotification");
			}

			const onCompanyTicketNotificationsPopover = (data) => {
				if (data.action === "updateUnread" || data.action === "delete") {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.ticketId);
						if (ticketIndex !== -1) {
							prevState.splice(ticketIndex, 1);
							return [...prevState];
						}
						return prevState;
					});

					setDesktopNotifications(prevState => {
						const notfiticationIndex = prevState.findIndex(
							n => n.tag === String(data.ticketId)
						);
						if (notfiticationIndex !== -1) {
							prevState[notfiticationIndex].close();
							prevState.splice(notfiticationIndex, 1);
							return [...prevState];
						}
						return prevState;
					});
				}
			};

// Adicione esta lógica no componente NotificationsPopOver
const onCompanyAppMessageNotificationsPopover = (data) => {
    if (
        data.action === "create" && !data.message.fromMe &&
        !data.message.read &&
        // "Conexões que pode atender": sem restrição é sempre true (nada muda)
        canSeeTicketConnection(user, data.ticket) &&
        (data.ticket?.userId === user?.id || !data.ticket?.userId) &&
        (user?.queues?.some(queue => (queue.id === data.ticket.queueId)) ||
            !data.ticket.queueId && showTicketWithoutQueue === true) &&
        (!["pending", "lgpd", "nps", "group"].includes(data.ticket?.status) ||
            (data.ticket?.status === "pending" && showNotificationPending === true) ||
            (data.ticket?.status === "group" && data.ticket?.whatsapp?.groupAsTicket === "enabled" && showGroupNotification === true) ||
            (data.ticket?.isGroup && data.ticket?.status === "pending" && showGroupNotification === true))
    ) {
        // Aplicar lógica de permissão para mensagens pending
        const shouldBlurMessages = data.ticket.status === "pending" && user.allowSeeMessagesInPendingTickets === "disabled";
        
        // Se deve ocultar a mensagem, modifique o ticket antes de adicioná-lo às notificações
        const ticketToAdd = shouldBlurMessages 
            ? {
                ...data.ticket,
                lastMessage: i18n.t("notifications.messageHidden") // ou "Mensagem oculta"
              }
            : data.ticket;

        setNotifications(prevState => {
            const ticketIndex = prevState.findIndex(t => t.id === ticketToAdd.id);
            if (ticketIndex !== -1) {
                prevState[ticketIndex] = ticketToAdd;
                return [...prevState];
            }
            return [ticketToAdd, ...prevState];
        });

        if (
            !shouldAlertMessage({
                data,
                currentTicketId: ticketIdRef.current,
                visibility: document.visibilityState,
                userId: user?.id,
                showGroupNotification,
                isMuted: contactId => isMutedRef.current(contactId),
            })
        ) return;

        // Para notificações desktop, também aplicar a lógica de ocultação
        const messageBody = shouldBlurMessages 
            ? i18n.t("notifications.messageHidden")
            : data.message.body;

        handleNotifications({
            ...data,
            message: {
                ...data.message,
                body: messageBody
            }
        });
    }
}

			socket.on("connect", onConnectNotificationsPopover);
			socket.on(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
			socket.on(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);

			return () => {
				socket.off("connect", onConnectNotificationsPopover);
				socket.off(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
				socket.off(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
			};
		}
		return undefined;
	}, [user, profile, queues, showTicketWithoutQueue, socket, showNotificationPending, showGroupNotification]);

	const handleNotifications = data => {
		const { message, contact, ticket } = data;

		const options = {
			body: `${message.body} - ${format(new Date(), "HH:mm")}`,
			icon: contact.urlPicture,
			tag: ticket.id,
			renotify: true,
		};
		const notification = new Notification(
			`${i18n.t("tickets.notification.message")} ${contact.name}`,
			options
		);

		notification.onclick = e => {
			e.preventDefault();
			window.focus();
			setTabOpen(ticket.status)
			historyRef.current.push(`/tickets/${ticket.uuid}`);
			// handleChangeTab(null, ticket.isGroup? "group" : "open");
		};

		setDesktopNotifications(prevState => {
			const notfiticationIndex = prevState.findIndex(
				n => n.tag === notification.tag
			);
			if (notfiticationIndex !== -1) {
				prevState[notfiticationIndex] = notification;
				return [...prevState];
			}
			return [notification, ...prevState];
		});
		soundAlertRef.current();
	};

	const handleClick = () => {
		setIsOpen(prevState => !prevState);
	};

	const handleClickAway = () => {
		setIsOpen(false);
	};

	const NotificationTicket = ({ children }) => {
		return <div onClick={handleClickAway}>{children}</div>;
	};

	const browserNotification = () => {
		const numbers = "⓿➊➋➌➍➎➏➐➑➒➓⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴";
		if (unreadCount > 0) {
			if (unreadCount < 21) {
				document.title = numbers.substring(unreadCount, unreadCount + 1) + " - " + (theme.appName || "...");
			} else {
				document.title = "(" + unreadCount + ")" + (theme.appName || "...");
			}
		} else {
			document.title = theme.appName || "...";
		}
		return (
			<>
				<Favicon
					animated={true}
					url={(theme?.appLogoFavicon) ? theme.appLogoFavicon : defaultLogoFavicon}
					alertCount={unreadCount}
					iconSize={195}
				/>
			</>
		);
	};

	return (
		<>
			{browserNotification()}

			<IconButton
				onClick={handleClick}
				ref={anchorEl}
				aria-label="Conversas não lidas"
				aria-haspopup="true"
				color="inherit"
			>
				<Badge
					overlap="rectangular"
					badgeContent={unreadCount}
					color="secondary"
					classes={{ badge: classes.badge }}
				>
					<PiChatCircleDots />
				</Badge>
			</IconButton>
			<Popover
				disableScrollLock
				open={isOpen}
				anchorEl={anchorEl.current}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				classes={{ paper: classes.popoverPaper }}
				onClose={handleClickAway}
			>
				<div className={classes.panelHeader}>
					{/* TODO i18n */}
					<h2 className={classes.panelTitle}>Conversas não lidas</h2>
					{notifications.length > 0 && (
						<span className={classes.panelCount}>{notifications.length}</span>
					)}
				</div>
				{notifications.length === 0 ? (
					<div className={classes.emptyState}>
						<ChatBubbleOutlineIcon />
						<span>{i18n.t("notifications.noTickets")}</span>
					</div>
				) : (
					<List dense className={classes.tabContainer}>
						{notifications.map(ticket => (
							<NotificationTicket key={ticket.id}>
								<TicketListItem ticket={ticket} />
							</NotificationTicket>
						))}
					</List>
				)}
			</Popover>
		</>
	);
};

export default NotificationsPopOver;